import { optionSearch_eventsForEmail } from './strings.locstring.json';
import { optionTitle_eventsForEmail } from 'owa-locstrings/lib/strings/optiontitle_eventsforemail.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullOptionV2'));
/**
 * Txp options settings
 */
let TxpOptionV2: LazyOption = createLazyOption(
    {
        key: 'txpV2',
        titleStringKey: optionTitle_eventsForEmail,
        searchTermsStringKey: optionSearch_eventsForEmail,
        hideTitleInFullOptions: true,
        isHidden: () => IsShadowMailboxUser(),
    },
    lazyFullModule,
    m => m.default
);
export default TxpOptionV2;
